export const handleChangeInputAddTransPage = (name, value) => ({
    type: 'CHANGE_INPUT_PAGE_ADD_TRANS', name, value
});